import { UserRole } from '../../core/auth/enums/userRoles';
import { StatusSeverity } from '../custom/statusSeverity';
const currentRole = (localStorage.getItem('role') ?? '').toLowerCase();
export enum RideStatusType {
  None = 12,
  InProgress = 13,
  Completed = 14,
  NoShow = 15,
  CanceledDueToHoliday = 16,
  CanceledInAdvance = 17,
  CanceledLate = 18,
  CanceledDueToPandemic = 19,
  Deleted = 20,
  Offered = 21,
  Accepted = 22,
  Declined = 23,
  Automatic = 24,
}
export const RideStatusDescription = (key: number) => {
  switch (key) {
    case RideStatusType.InProgress:
      return 'In Progress';
    case RideStatusType.Accepted:
      return 'Accepted';
    case RideStatusType.Offered:
      return 'Offered';
    case RideStatusType.Completed:
      return 'Completed';
    case RideStatusType.NoShow:
      return 'No-show';
    case RideStatusType.CanceledDueToHoliday:
      return 'Holiday';
    case RideStatusType.CanceledDueToPandemic:
      return 'Canceled Due to Pandemic';
    case RideStatusType.CanceledInAdvance:
      return 'Early Cancelled';
    case RideStatusType.CanceledLate:
      return 'Late Cancelled';
    case RideStatusType.Deleted:
      return 'Deleted';
    case RideStatusType.Declined:
      return 'Declined';
    default:
      return 'none';
  }
};

export const GetRideStatusSeverity = (status: string, showRideAttention: boolean): StatusSeverity => {
  if (showRideAttention) {
    status = 'RedBadge';
  }
  switch (status) {
    case 'Scheduled':
    case 'Schedule':
    case 'In Progress':
    case 'Accepted':
    case 'Offered':
      return 'info';
    case 'Deleted':
    case 'Declined':
    case 'Driver 2X Booked':
    case 'Driver & Monitor 2X Booked':
    case 'Monitor 2X Booked':
    case 'Driver not Assigned':
    case 'RedBadge':
      return 'danger';
    case 'Canceled Due to Pandemic':
    case 'Early Cancellation':
    case 'Early Cancelation':
    case 'Early Cancelled':
    case 'Holiday':
      return 'secondary';
    case 'No-show':
    case 'Late Cancellation':
    case 'Late Cancelation':
    case 'Late Cancelled':
      return currentRole == UserRole.Admin ? 'danger' : 'success';
    case 'Completed':
      return 'success';
    default:
      return 'warning';
  }
};
